import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import DispatchService from "../services/DispatchService";
import { useBrand } from "../helper/BrandContext";

const TrackingReport = ({ isLoggedIn }) => {
  const [journeyList, setJourneyList] = useState([]);
  const [scanTxt, setScanTxt] = useState("");
  const [qrs, setQrs] = useState(true);
  const { brand } = useBrand();

  const Dispatch = new DispatchService();
  const navigate = useNavigate();
  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setJourneyList([]);
    setScanTxt("");
  }, [brand]);

  const ScanItem = (e) => {
    if (e.key === "Enter") {
      let qr = e.target.value;
      const brandToSend = brand || "1";
      if (qr.includes("DID") || qr.includes("SID")) {
        Dispatch.GetJourney(qr, brand).then((data) => {
          const resdata = data;
          if (resdata.responseCode === "200") {
            setJourneyList(resdata.responseData);
            setQrs(true);
          } else if (resdata.responseCode === "400") {
            toast.error(resdata.responseMessage);
          } else {
            toast.error(resdata.responseMessage);
          }
        });
      } else if (qr.includes("/pa?U")) {
        Dispatch.GetJourney(qr, brandToSend).then((data) => {
          const resdata = data;
          if (resdata !== null && resdata.responseCode === "200") {
            setJourneyList(resdata.responseData);
            setQrs(true);
          } else if (resdata.responseCode === "400") {
            toast.error(resdata.responseMessage);
          } else {
            toast.error(resdata.responseMessage);
          }
        });
      } else {
        Dispatch.GetJourney(qr, brandToSend).then((data) => {
          const resdata = data;
          if (resdata !== null && resdata.responseCode === "200") {
            setJourneyList(resdata.responseData);
            setQrs(true);
          } else if (resdata.responseCode === "400") {
            toast.error(resdata.responseMessage);
          } else {
            toast.error(resdata.responseMessage);
          }
        });
      }
      setScanTxt("");
    }
  };

  const mystyle = {
    minHeight: 90 * journeyList.length + "px",
  };

  return (
    <>
      <div className="heading mb-1">
        <h2 className="qrcodetracking p-3">QR & Shippers Tracking Report</h2>
      </div>

      <div className="col-md-1 mb-2 ml-3">
        <input
          style={{ width: "300px" }}
          onChange={(e) => setScanTxt(e.target.value)}
          name="scanTxt"
          value={scanTxt}
          type="search"
          autoComplete="off"
          className="form-control ml-2"
          id="scan"
          onKeyDown={(e) => ScanItem(e)}
          autoFocus
        />
      </div>
      <div className="col-md-12 abqrcol">
        <div className="col-md-12" style={{ marginBottom: "10vh" }}>
          {qrs && (
            <div className="card_qr p-5">
              <ul className="timeline" style={mystyle}>
                {journeyList.map((value, index) => (
                  <li key={index}>
                    {value.activity}{" "}
                    {value.date ? (
                      <span>
                        <i
                          className="pi pi-calendar"
                          style={{ color: "Blue" }}
                        ></i>{" "}
                        {value.date}
                      </span>
                    ) : null}{" "}
                    {value.location ? (
                      <span>
                        <i className="pi pi-globe" style={{ color: "red" }}></i>{" "}
                        {value.location}
                      </span>
                    ) : null}
                    {value.status ? (
                      <span>
                        <i
                          className="pi pi-comment"
                          style={{ color: "red" }}
                        ></i>{" "}
                        {value.status}
                      </span>
                    ) : null}{" "}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      <div></div>
    </>
  );
};

export default TrackingReport;
